<template>
  <v-container>
    <v-row dense>
      <v-col cols="6">
        <v-card
          color="#00CA63"
          dark
          shaped
        >
          <v-card-title class="headline">Redações corrigidas</v-card-title>

          <v-card-subtitle>Número de redações corrigidas por você</v-card-subtitle>

          <v-card-text>
            <v-row align="center">
              <v-col class="display-3" cols="6">
                {{corrected}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined :loading="loading" @click="getCorrected()">Atualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          color="#0077BE"
          dark
          shaped
        >
          <v-card-title class="headline">Redações a serem corrigidas</v-card-title>

          <v-card-subtitle>Redações disponíveis para correção</v-card-subtitle>

          <v-card-text>
            <v-row align="center">
              <v-col class="display-3" cols="6">
                {{toCorrect}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined :loading="loadingToCorrect" @click="getCountToCorrect()">Atualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          color="#0077BE"
          dark
          shaped
        >
          <v-card-title class="headline">Corrigir redação</v-card-title>
          <v-card-actions>
            <v-btn
              :disabled="!continueReview"
              color="white"
              @click="goToCorrectEssay()"
              outlined
            >
              Continuar
            </v-btn>
            <v-btn
              :disabled="continueReview"
              color="white"
              @click="goToCorrectEssay()"
              outlined
            >
              Nova
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EssayService from '@/services/essay/essay'
import localforage from 'localforage'

export default {
  name: 'EssayReviewer',
  data: () => ({
    essayWidthBox: 294,
    EssayService: new EssayService(),
    essaysOutstanding: {},
    corrected: 0,
    toCorrect: 0,
    loading: false,
    loadingToCorrect: false,
    continueReview: null,
    essayId: null
  }),
  async mounted () {
    try {
      this.continueReview = !!await localforage.getItem('essay')
      console.log(this.continueReview)
    } catch (error) {
      console.log(error)
    }
    this.listToCorrect()
    this.getCorrected()
    this.getCountToCorrect()
  },
  methods: {
    checkIfPassFiveDays (dateInit) {
      const today = new Date().getTime()
      const diferenceInTime = today - dateInit
      const diferenceInDays = diferenceInTime / (1000 * 3600 * 24)
      return diferenceInDays > 2
    },
    async goToCorrectEssay () {
      if (this.continueReview) {
        if (this.checkIfPassFiveDays(this.continueReview.dateInit)) {
          try {
            const value = await localforage.clear()
            console.log(value)
          } catch (error) {
            console.log(error)
          }
          this.$router.push({
            name: 'correcao',
            params: {
              id: this.essaysOutstanding[0].id
            }
          })
          return
        }
      }
      if (!this.continueReview) {
        try {
          const value = await localforage.clear()
          console.log(value)
        } catch (error) {
          console.log(error)
        }
        this.$router.push({
          name: 'correcao',
          params: {
            id: this.essaysOutstanding[0].id
          }
        })
        return
      }

      try {
        const essay = await localforage.getItem('essay')
        this.essayId = essay.id

        this.$router.push({
          name: 'correcao',
          params: {
            id: this.essayId
          }
        })
        console.log(essay)
      } catch (error) {
        console.log(error)
      }
    },
    async listToCorrect () {
      try {
        const { data } = await this.EssayService.listEssayToReviewer()
        this.essaysOutstanding = data
      } catch (error) {
        console.log(error)
      }
    },
    async getCorrected () {
      this.loading = true
      try {
        const { data } = await this.EssayService.getCorrected()
        this.corrected = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCountToCorrect () {
      this.loadingToCorrect = true
      try {
        const { data } = await this.EssayService.getCountToCorrect()
        this.toCorrect = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingToCorrect = false
      }
    }
  }
}
</script>

<style scoped>
.container-background {
  height: 100%;
}
.h3-section {
  font-size: 25px;
  font-weight: 600;
}
/* BOX */
.box:hover {
  background: none;
  background-color: rgb(27, 113, 195, 0.8);
}
.h3-padding-bottom {
  padding-bottom: 1rem;
}
.input-margin {
  margin-top: 1em;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .input-margin {
    margin-top: 0;
  }
}
</style>
